<template>
    <div :style="{...style, backgroundColor, height, minHeight: minHeight}">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: 'Sheet',
        props:{
            backgroundColor:{
                type: String,
                default: '#fff'
            },
            height:{
                type: String,
                default: 'auto'
            },
            minHeight:{
                type: String,
                default: '720px'
            }
        },
        computed:{
            style(){
                return ({
                    padding: '20px 20px',
                    boxShadow: '0 2px 12px 0 rgba(0, 0, 0, 0.1)',
                    margin: '20px 20px'
                });
            }
        }
    }
</script>

<style>
</style>